// @flow
// we need to transform devmoderation links to localhost when developing locally

const MODERATION_URL_REGEX = /^(https?:)?\/\/(dev|qa)?moderation\.powerreviews\.com\/#/;

export default function tx(apps: $PropertyType<LoginResponseBody, 'apps'>) {
  return apps.map(app => ({
    ...app,
    href: app.href.replace(MODERATION_URL_REGEX, ''),
  }));
}



// WEBPACK FOOTER //
// ./src/ducks/normalizeModerationPaths.js